import React, { useState, useEffect, useRef, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setNotificationSoundPlayed } from "../../redux/actions";
import { Link, NavLink, useHistory } from "react-router-dom";
import Badge from "@material-ui/core/Badge";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { getStringfromSeconds } from "../../functions/index";
import "./index.css";
import Firebase from "../../firebasehelper";
import {
  populateMissingTabs,
  populateMissingPermissions,
} from "../../Utils/utils";
const comingsoon_img = require("../../assets/media/coming-soon.png");
const default_logo = require("../../assets/media/logo.png");
const appointment_img = require("../../assets/media/headers/appointment.svg");
const review_img = require("../../assets/media/headers/rating.png");
const support_img = require("../../assets/media/headers/chat.svg");
const admin_img = require("../../assets/media/headers/admin.png");
const notification_gif = require("../../assets/media/headers/notification.gif");
const signout_img = require("../../assets/media/headers/signout.png");
const dashboard_img = require("../../assets/media/headers/dashboard.png");
const schedule_img = require("../../assets/media/schedule.png");
const diversity_img = require("../../images/diversity.svg");
const unreadMsgAudio = require("../../assets/media/audio/unread-msg.mp3");
const unreadMsg = new Audio(unreadMsgAudio);

const compare = (a, b) => {
  return b.time - a.time;
};

const Message = ({ unread_item }) => {
  const text = unread_item.latest;
  const time = getStringfromSeconds(unread_item.time);
  return (
    <div className="notification_item">
      <p>{text}</p>
      <p className="time">{time}</p>
    </div>
  );
};

const Header = (props) => {
  const {
    username,
    onHome,
    role,
    logo,
    brand,
    is_property_brand,
    is_tasktool_need,
    brandName,
    setHasMore,
  } = props;

  const [umbrellaBrandData, setUmbrellaBrandData] = useState(null);
  const [isMobileView, setMobileView] = useState(false);
  const [unread_open, setUnreadOpen] = useState(false);
  const [isBrand, setIsBrand] = useState(false);
  const [current_unreads, setCurrentUnReads] = useState([]);
  const [isCRMChatNotAvailable, setIsCRMChatNotAvailable] = useState(false);
  const [isHotContentVisible, setIsHotContentVisible] = useState(false);
  const [isIntegrationAllow, setIsIntegrationAllow] = useState(false);
  const [logInOptions, setLoginOptions] = useState({
    email: false,
    chatbot: true,
  });
  const [permissions, setPermissions] = useState({});
  const [crmTabs, setCRMTabs] = useState({});
  const [agencyData, setAgencyData] = useState({});
  const [brand_data, setBrandData] = useState({});

  const unreads = useSelector((state) => state.unreads);
  const profile = useSelector((state) => state.profile);
  const brand_unreads = useSelector((state) => state.brand_unreads);
  const super_unreads = useSelector((state) => state.super_unreads);
  const hasPlayed = useSelector((state) => state.hasPlayed);

  const badgeRef = useRef();
  const history = useHistory();
  const dispatch = useDispatch();
  const uid = localStorage.getItem("uid");

  const umbrellaBrand =
    localStorage.getItem("umbrella") &&
    Number(localStorage.getItem("umbrella"));

  // If website is admin website, and user is brand admin or umbrella admin
  const isUmbrella =
    process.env.REACT_APP_USER === "admin" && (role === 2 || role === 10);
  const isAdmin = process.env.REACT_APP_USER === "admin";
  useEffect(() => {
    if (!brand) return;
    const isBrand = brand !== undefined && brand !== umbrellaBrand;
    Firebase.getBrandDataByID(brand, (res) => {
      // const isCRMChatNotAvailable =
      //   res &&
      //   res.permissions &&
      //   !res.permissions.concierge &&
      //   !res.permissions.tickets &&
      //   !res.permissions.newchat;
      setBrandData(res);

      // TODO: setIsCRMChatNotAvailable, setIsHotContentVisible, setIsIntegrationAllow
      // appear to be redundant and could potentially be removed
      const isCRMChatAvailable = res.is_ecochat_need;
      setIsCRMChatNotAvailable(!isCRMChatAvailable);
      setIsHotContentVisible(
        res && res.permissions && res.permissions.hotTopic
      );
      setIsIntegrationAllow(
        res && res.permissions && res.permissions.integration
      );

      const populatedPermissions = populateMissingPermissions(res.permissions);
      res && setPermissions(populatedPermissions);

      // Note: We use this code to fill in any crm tabs that are missing
      // from brands created before 15th Feb 2024 to avoid unexpected behavior
      const updatedTabs = populateMissingTabs(res.crmTabs);
      res && setCRMTabs(updatedTabs);

      res.logIn && setLoginOptions(res.logIn);
    });
    setIsBrand(isBrand);
    Firebase.getAgencyData(uid, (res) => {
      setAgencyData(res);
    });
  }, [brand]);
  const playSoundForUnreadMessages = (msgArray) => {
    setTimeout(() => {
      if (msgArray.length && !hasPlayed) {
        unreadMsg.play();

        // Note: Since almost no page shares the header component, the header
        // will mount every time a new page is rendered. This results in
        // the notification sound being played every time admins navigate to a new page.
        // Therefore, we set a boolean to global state to avoid this.
        dispatch(setNotificationSoundPlayed(true));
      }
    }, 1000);
  };
  useEffect(() => {
    const allUnreads = isBrand
      ? [...unreads, ...brand_unreads]
      : [...super_unreads];

    setCurrentUnReads(allUnreads);
    !isCRMChatNotAvailable && playSoundForUnreadMessages(allUnreads);
  }, [unreads, super_unreads, brand_unreads, isBrand]);

  const checkDeviceStatus = () => {
    setMobileView(window.innerWidth < 1024);
  };
  useEffect(() => {
    checkDeviceStatus();
    window.addEventListener("resize", checkDeviceStatus);
  }, []);

  const onSignOut = () => {
    history.push("/");
    localStorage.clear();
  };

  const goToCommunity = () => {
    window.open(
      `https://ecosystem.club/${(brandName || "")
        .replace(/\s/g, "")
        .toLowerCase()}`,
      "_blank"
    );
  };

  const goToAdminSupport = () => {
    history.push("/admin-support", {
      username: username,
      role: role,
      brand: brand,
    });
  };

  const goDashboard = () => {
    var user_data = profile;
    if (!user_data) user_data = localStorage.getItem("profile");
    const path =
      user_data &&
      (user_data.type === "Content and marketing" ||
        user_data.type === "Content Admin")
        ? "/planner" // planner is currently disabled
        : "/dashboard";
    history.push(path, {
      username: username,
      role: role,
      brand: brand,
    });
  };

  const goToBrandAdmins = () => {
    var user_data = profile;
    if (!user_data) user_data = localStorage.getItem("profile");

    history.push("/brand-admins", {
      username: username,
      role: role,
      brand: brand,
      agencyData: agencyData,
    });
  };

  const goToCalendarHub = () => {
    history.push("/calendar-hub", {
      username: username,
      role: role,
      brand: brand,
    });
  };

  const goToTicketSubmissionSite = () => {
    window.open(
      `https://ecosystem.club/${(brandName || "")
        .replace(/\s/g, "")
        .toLowerCase()}?page=tasksubmissionsite`,
      "_blank"
    );
  };

  useEffect(() => {
    if (umbrellaBrand === undefined) return;
    Firebase.getBrandDataByID(umbrellaBrand, (res1) => {
      setUmbrellaBrandData(res1);
    });
  }, [umbrellaBrand]);

  const comingSoonList = [
    "Sign-up forms",
    "Schedule in content and campaign creators",
    "Sales Reports",
  ];

  const CommonMenuItem = ({
    className,
    route,
    title,
    state,
    label,
    disabled,
    onPress,
    externalLink,
    icon,
    isWhiteFont,
    hex = "#faff87",
    setHasMore,
    isContentTab,
  }) => {
    const [isHover, setIsHover] = useState(false);

    const onClickHandler = () => {
      if (setHasMore) setHasMore(true);
    };

    return (
      <li
        className="nav-main-item"
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        onClick={onClickHandler}
      >
        {!externalLink && (
          <Link
            to={{
              pathname: disabled ? "" : route,
              state: state || {
                username: username,
                role: role,
                brand: brand,
                agencyData: agencyData,
              },
            }}
            className={`nav-main-link ${className} ${
              comingSoonList.includes(label) ? "not-hover" : ""
            }`}
            style={
              isHover
                ? {
                    backgroundColor: hex,
                    color: isWhiteFont ? "#FFFFFF" : "",
                  }
                : {}
            }
            onClick={(e) => {
              if (disabled) {
                e.preventDefault();
              } else if (onPress) {
                e.preventDefault();
                onPress && onPress();
              }
            }}
          >
            {isContentTab ? <div className="nav-main-item__icon" /> : null}
            <span
              className={`nav-main-link-name ${
                title && "nav-main-link-name-highlight"
              } ${
                isHover && comingSoonList.includes(label)
                  ? "nav-main-link-name-hover"
                  : ""
              }`}
            >
              {icon && (
                <img
                  src={icon}
                  style={{ width: "24px", marginRight: "10px" }}
                />
              )}
              {title && <b className="menu-title">{title}</b>}
              {label}
            </span>
            {isHover && comingSoonList.includes(label) && (
              <img
                src={comingsoon_img}
                alt="icon"
                style={{ width: "20px", height: "20px", marginRight: "10px" }}
              />
            )}
          </Link>
        )}
        {externalLink && (
          <a
            className={`nav-main-link ${
              comingSoonList.includes(label) ? "not-hover" : ""
            }`}
            target="_blank"
            href={`https://savingrobot.io/${(brandName || "")
              .replace(/\s/g, "")
              .toLowerCase()}`}
          >
            <span
              className={`nav-main-link-name ${
                title ? "nav-main-link-name-highlight" : ""
              }`}
              style={isHover ? { backgroundColor: hex } : {}}
            >
              {icon && <img src={icon} style={{ width: "16px" }} />}
              {title && <b>{title}</b>}
              {label}
            </span>
            {isHover && comingSoonList.includes(label) && (
              <img src={comingsoon_img} alt="icon" width="30px" />
            )}
          </a>
        )}
      </li>
    );
  };

  const MenuGroupTitle = ({ title }) => {
    return (
      <li className="nav-main-item">
        <p className="nav-group-title">{title}</p>
      </li>
    );
  };

  const CommonMenuButton = ({
    children,
    isWhiteFont,
    hex = "#faff87",
    ...props
  }) => {
    const [isHover, setIsHover] = useState(false);
    return (
      <button
        {...props}
        style={
          isHover
            ? { backgroundColor: hex, color: isWhiteFont ? "#FFFFFF" : "" }
            : {}
        }
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        {children}
      </button>
    );
  };

  let tabsOrder = !isBrand
    ? ["Sales manager", "Sales rep", "Service manager", "Service rep"].includes(
        agencyData.type
      )
      ? ["community", "referrals"]
      : [
          // super brands
          "deal",
          "community",
          "superContent",
          "connect",
          "marketplace",
          "rewards",
          "ecoBanking",
          "engagement",
          "products",
          "superAnalytics",
          "superIntegration",
          // "userPlatform",
        ]
    : ["Sales manager", "Sales rep", "Service manager", "Service rep"].includes(
        agencyData.type
      )
    ? ["community", "referrals"]
    : [
        // normal brand
        "community",
        "referrals",
        "content",
        "gamification",
        "rewards",
        "marketplace",
        "tasks",
        "bespoke",
        "programme",
        "support",
        "propertyPortals",
        "superAnalytics",
        "engagement",
        "products",
        "integration",
        // "userPlatform",
      ];

  if (isMobileView && process.env.REACT_APP_USER !== "admin") {
    tabsOrder = [];
  }

  const initialiseTab = (tabName) => {
    if (isAdmin) return true;
    return crmTabs.hasOwnProperty(tabName) ? crmTabs[tabName] : true;
  };

  const headers = {
    programme: initialiseTab("Programme"),
    support: initialiseTab("Support Chat"),
    community: initialiseTab("Community + Chat"),
    referrals: initialiseTab("Onboarding + Referral"),
    gamification: initialiseTab("Gamification"),
    rewards: initialiseTab("Rewards"),
    marketplace: !brand || brand === 0 ? false : initialiseTab("Marketplace"),
    bespoke: initialiseTab("Bespoke"),
    integration: initialiseTab("Integration"),
    content: initialiseTab("Social + Content"),
    tasks: is_tasktool_need,
    propertyPortals: is_property_brand,
    connect: isBrand,
    // exclusively super admin tabs
    deal: !isBrand && !isUmbrella,
    superContent: !isBrand,
    ecoBanking: !isBrand,
    superAnalytics: !isBrand,
    engagement: !isBrand,
    products: !isBrand,
    userPlatform: isBrand,
    superIntegration: !isBrand,
  };
  const renderContentHeader = () => {
    const gotoPath = (pathname) =>
      history.push({
        pathname,
        state: {
          username,
          role,
          brand,
        },
      });

    return (
      <Fragment>
        {/* <CommonMenuButton
          type="button"
          className="btn nav-btn top-btn"
          onClick={() => gotoPath("/planner")}
          hex={brand_data.hex}
          isWhiteFont={brand_data.white}
        >
          Planner
        </CommonMenuButton> */}

        {isHotContentVisible && (
          <CommonMenuButton
            type="button"
            className="btn nav-btn top-btn"
            onClick={() => gotoPath("/hot-topic")}
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
          >
            Hot Topic
          </CommonMenuButton>
        )}
        <CommonMenuButton
          type="button"
          className="btn nav-btn top-btn"
          onClick={() => gotoPath("/featured-content")}
          hex={brand_data.hex}
          isWhiteFont={brand_data.white}
        >
          Featured Content
        </CommonMenuButton>
        {permissions.feeds && (
          <CommonMenuButton
            type="button"
            className="btn nav-btn top-btn"
            onClick={() => gotoPath("/feeds")}
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
          >
            News Feed
          </CommonMenuButton>
        )}
        {permissions.articles && (
          <CommonMenuButton
            type="button"
            className="btn nav-btn top-btn"
            onClick={() => gotoPath("/articles")}
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
          >
            Article
          </CommonMenuButton>
        )}
        {permissions.polls && (
          <CommonMenuButton
            type="button"
            className="btn nav-btn top-btn"
            onClick={() => gotoPath("/polls")}
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
          >
            Polls
          </CommonMenuButton>
        )}
        {permissions.survey && (
          <CommonMenuButton
            type="button"
            className="btn nav-btn top-btn"
            onClick={() => gotoPath("/survey")}
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
          >
            Survey
          </CommonMenuButton>
        )}
        <CommonMenuButton
          type="button"
          className="btn nav-btn top-btn"
          onClick={() => gotoPath("/checklist")}
          hex={brand_data.hex}
          isWhiteFont={brand_data.white}
        >
          Checklist
        </CommonMenuButton>
        {/* <CommonMenuButton
          type="button"
          className="btn nav-btn top-btn"
          onClick={() => gotoPath("/competitions")}
          hex={brand_data.hex}
          isWhiteFont={brand_data.white}
        >
          Compete
        </CommonMenuButton> */}
        {/* <CommonMenuButton
          type="button"
          className="btn nav-btn top-btn"
          onClick={() => gotoPath("/perks")}
          hex={brand_data.hex}
          isWhiteFont={brand_data.white}
        >
          Offers
        </CommonMenuButton> */}
        {permissions.events && (
          <CommonMenuButton
            type="button"
            className="btn nav-btn top-btn"
            onClick={() => gotoPath("/event")}
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
          >
            Event
          </CommonMenuButton>
        )}
      </Fragment>
    );
  };
  const renderSupportTab = () => (
    <div className="dropdown d-inline-block" key="support">
      <CommonMenuButton
        type="button"
        className="btn top-btn"
        hex={brand_data.hex}
        isWhiteFont={brand_data.white}
        onClick={() =>
          history.push({
            pathname: "/admin-support",
            state: {
              username,
              role,
              brand,
            },
          })
        }
      >
        Support
      </CommonMenuButton>
    </div>
  );
  const renderProgrammeTab = () => (
    <div className="dropdown d-inline-block" key="programme">
      <CommonMenuButton
        type="button"
        className="btn nav-btn top-btn"
        id="page-header-notifications-dropdown"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        hex={brand_data.hex}
        isWhiteFont={brand_data.white}
      >
        Programme
      </CommonMenuButton>
      <div
        className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
        aria-labelledby="page-header-notifications-dropdown"
      >
        <div className="p-2 border-top">
          {/* <CommonMenuItem
            route="/admin-support"
            title="Admin support"
            label="Ecosystem assistance"

          /> */}
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/user-platform"
            label="Plans"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/brand"
            label="Company Info"
          />
          <div style={{ height: "10px" }} />
          {/* <CommonMenuItem
            hex={brand_data.hex}
            route="/analytics"
            label="Visit your community ecosystem"
            onPress={goToCommunity}
          /> */}
          <div style={{ height: "10px" }} />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/brand-admins"
            label={`${brandName ? `${brandName} ` : ""}Admins`}
          />
          {/* <CommonMenuItem
            route="/brand-taskers"
            label={`${brandName ? `${brandName} ` : ""}Taskers`}
          /> */}
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/brand-developers"
            label={`${brandName ? `${brandName} ` : ""}Developers`}
          />
          {/* TODO: the below tabs are disabled because they don't lead anywhere */}
          {/* <div style={{ height: "10px" }} />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/analytics"
            label="Analytics"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            disabled
            label="KPIS"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            disabled
            label="Reviews"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            disabled
            label="Referrals"
          />
          <div style={{ height: "10px" }} />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            disabled
            label="Test Roll Out Guide"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            disabled
            label="Data & API Guide"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            disabled
            label="Workshops Guide"
          />
          <div style={{ height: "10px" }} />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/privacypolicy"
            label="User Privacy Policy"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/terms&conditions"
            label="User T&Cs"
          /> */}
        </div>
      </div>
    </div>
  );

  const renderDealTab = () => (
    <div className="dropdown d-inline-block" key="deal">
      <CommonMenuButton
        type="button"
        className="btn nav-btn top-btn"
        id="page-header-notifications-dropdown"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        hex={brand_data.hex}
        isWhiteFont={brand_data.white}
      >
        Deal Flow
      </CommonMenuButton>
      <div
        className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
        aria-labelledby="page-header-notifications-dropdown"
      >
        <div className="p-2 border-top">
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/channel"
            label="Prospect communities"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/pending-communities"
            label="Pending communities"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/completed-deals"
            label="Active communities"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/campaign-deals"
            label="Campaign roll outs"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/platform-links"
            label="Platform links"
          />
        </div>
      </div>
    </div>
  );

  const renderCommunityTab = () =>
    !isBrand && isUmbrella ? (
      <CommonMenuItem
        hex={brand_data.hex}
        isWhiteFont={brand_data.white}
        className="btn nav-btn"
        route="/umbrella-channel"
        label="Community"
      />
    ) : [
        "Sales manager",
        "Sales rep",
        "Service manager",
        "Service rep",
      ].includes(agencyData.type) ? (
      <CommonMenuItem
        hex={brand_data.hex}
        isWhiteFont={brand_data.white}
        className="btn nav-btn"
        route="/users"
        label="Community + Chat"
        setHasMore={setHasMore}
      />
    ) : (
      <div className="dropdown d-inline-block" key="community">
        <CommonMenuButton
          type="button"
          className="btn nav-btn top-btn"
          id="page-header-notifications-dropdown"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          hex={brand_data.hex}
          isWhiteFont={brand_data.white}
          // TODO: below code disabled temporarily
          // setHasMore={
          //   isAdmin && !isUmbrella && !isBrand ? undefined : setHasMore
          // }
        >
          {isAdmin && !isUmbrella && !isBrand
            ? "License Management"
            : "Community + Chat"}
        </CommonMenuButton>
        <div
          className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
          aria-labelledby="page-header-notifications-dropdown"
        >
          <div className="p-2 border-top">
            {isBrand ? (
              <React.Fragment>
                {!isCRMChatNotAvailable &&
                  ![
                    "Sales manager",
                    "Sales rep",
                    "Service manager",
                    "Service rep",
                  ].includes(agencyData.type) && (
                    <CommonMenuItem
                      hex={brand_data.hex}
                      isWhiteFont={brand_data.white}
                      icon={support_img}
                      route="/chatsuite"
                      label="Community chat and ticket management"
                    />
                  )}
                <CommonMenuItem
                  hex={brand_data.hex}
                  isWhiteFont={brand_data.white}
                  route="/users"
                  label="View and manage your community"
                  icon={diversity_img}
                />
                {/* <CommonMenuItem
                    onPress={goToCommunity}
                    label="Visit your community ecosystem"
                  /> */}
                {agencyData &&
                  ![
                    "Content and marketing",
                    "Content Admin",
                    "Sales manager",
                    "Sales rep",
                    "Service manager",
                    "Service rep",
                  ].includes(agencyData.type) && (
                    <CommonMenuItem
                      hex={brand_data.hex}
                      isWhiteFont={brand_data.white}
                      icon={review_img}
                      route="/viewreviews"
                      label="View reviews content"
                    />
                  )}
                {!isCRMChatNotAvailable &&
                  ![
                    "Sales manager",
                    "Sales rep",
                    "Service manager",
                    "Service rep",
                  ].includes(agencyData.type) && (
                    <CommonMenuItem
                      hex={brand_data.hex}
                      isWhiteFont={brand_data.white}
                      icon={appointment_img}
                      route="/calendar-hub"
                      label="View and manage your appointments"
                    />
                  )}
                {![
                  "Sales manager",
                  "Sales rep",
                  "Service manager",
                  "Service rep",
                ].includes(agencyData.type) && (
                  <CommonMenuItem
                    hex={brand_data.hex}
                    isWhiteFont={brand_data.white}
                    // route="/user-categories"
                    label="Schedule in content and campaign creators"
                    icon={schedule_img}
                  />
                )}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <CommonMenuItem
                  hex={brand_data.hex}
                  isWhiteFont={brand_data.white}
                  route="/contracts"
                  label="Contracts"
                />
                <CommonMenuItem
                  hex={brand_data.hex}
                  isWhiteFont={brand_data.white}
                  route="/team"
                  label="Ecosystem Sales Team"
                />
                <CommonMenuItem
                  hex={brand_data.hex}
                  isWhiteFont={brand_data.white}
                  route="/introducer"
                  label="Ecosystem introducer partners"
                />
                {role === 0 && (
                  <CommonMenuItem
                    hex={brand_data.hex}
                    isWhiteFont={brand_data.white}
                    route="/super-admins"
                    label="Ecosystem Super Admins"
                  />
                )}
                {role === 0 && (
                  <CommonMenuItem
                    hex={brand_data.hex}
                    isWhiteFont={brand_data.white}
                    route="/umbrella"
                    label="Umbrella Brands"
                  />
                )}
                {role === 0 && (
                  <CommonMenuItem
                    hex={brand_data.hex}
                    isWhiteFont={brand_data.white}
                    route="/umbrella-admins"
                    label="Umbrella Admins"
                  />
                )}
                {role === 0 && (
                  <CommonMenuItem
                    hex={brand_data.hex}
                    isWhiteFont={brand_data.white}
                    route="/super-investors"
                    label="Investors"
                  />
                )}
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    );

  const renderConnectTab = () => (
    <div className="dropdown d-inline-block" key="connect">
      <CommonMenuButton
        type="button"
        className="btn nav-btn top-btn"
        id="page-header-notifications-dropdown"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        hex={brand_data.hex}
        isWhiteFont={brand_data.white}
      >
        Connect + Chat
      </CommonMenuButton>
      <div
        className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
        aria-labelledby="page-header-notifications-dropdown"
      >
        <div className="p-2 border-top">
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/chatsuite"
            title="User Interaction Hub"
            label="Tickets & Chat"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/admin-support"
            title="Admin support"
            label="Ecosystem assistance"
          />
          {/* <CommonMenuItem route="/chatbots" title="EcoChat" label="Chatbots" /> */}
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/calendar-hub"
            title="CalendarHub"
            label="All appointments"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/chatbot-maker"
            title="ChatBots"
            label="Chatbot maker"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/auto-concierge"
            title="ConciergeBot"
            label="Daily auto-interactions"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/chatbot"
            title="EcoPA"
            label="Personal Assistants"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/welcome-message"
            title="WelcomeBot"
            label="Bespoke messages"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/login-bot"
            title="LoginBot"
            label="Bespoke welcome message"
          />
        </div>
      </div>
    </div>
  );

  const renderReferralsTab = () => {
    if (["Service manager", "Service rep"].includes(agencyData.type))
      return null;
    return ["Sales manager", "Sales rep"].includes(agencyData.type) ? (
      <CommonMenuItem
        hex={brand_data.hex}
        isWhiteFont={brand_data.white}
        className="btn nav-btn"
        route="/referrals"
        label="Acquisition + Onboarding"
      />
    ) : (
      <div className="dropdown d-inline-block" key="referrals">
        <CommonMenuButton
          type="button"
          className="btn nav-btn top-btn"
          id="page-header-notifications-dropdown"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          hex={brand_data.hex}
          isWhiteFont={brand_data.white}
        >
          Onboarding + Referral
        </CommonMenuButton>
        <div
          className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
          aria-labelledby="page-header-notifications-dropdown"
        >
          <div className="p-2 border-top">
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route="/referrals"
              label="Member referrals"
            />
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route="/registration"
              label="Community registrations"
            />
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route="/onboarding-site"
              label="Create an onboarding site"
            />
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              label="Sign-up forms"
            />
          </div>
        </div>
      </div>
    );
  };

  const renderContentTab = () => (
    <div className="dropdown d-inline-block" key="content">
      <CommonMenuButton
        type="button"
        className="btn nav-btn top-btn"
        id="page-header-notifications-dropdown"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        hex={brand_data.hex}
        isWhiteFont={brand_data.white}
      >
        Social + Content
      </CommonMenuButton>
      <div
        className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
        aria-labelledby="page-header-notifications-dropdown"
      >
        <div className="p-2 border-top" style={{ width: "max-content" }}>
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/planner"
            title="Content Planner"
            label="Plan content & engagement"
            isContentTab={true}
          />
          {/* <CommonMenuItem
            route={"/cause"}
            title="Gamification Cause"
            label="Donate and earn"
          /> */}
          {/* <CommonMenuItem
            route="/advent-planner"
            label="Advent Calendar planner"
          /> */}
          {isHotContentVisible && (
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route={"/hot-topic"}
              title="Hot Topic"
              label="Broadcast hot talking points and videos"
              isContentTab={true}
            />
          )}
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route={"/featured-content"}
            title="Featured Content"
            label="Add a leading content banner"
            isContentTab={true}
          />
          {permissions.feeds && (
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              title="News Feed"
              route="/feeds"
              label="Post content to your feeds"
              isContentTab={true}
            />
          )}
          {permissions.articles && (
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              title="Article"
              route="/articles"
              label="Longform topical article"
              isContentTab={true}
            />
          )}
          {permissions.polls && (
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              title="Polls"
              route="/polls"
              label="List & manage user polls"
              isContentTab={true}
            />
          )}
          {permissions.survey && (
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              title="Survey"
              route="/survey"
              label="Manage multiple answer surveys"
              isContentTab={true}
            />
          )}
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            title="Checklist"
            route="/checklist"
            label="Collect data and tick off"
            isContentTab={true}
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            title="Portfolio"
            route="/portfolio"
            label="Present your scope of work"
            isContentTab={true}
          />
          {/* FIXME: disabled competition tab as Chris said it is too buggy */}
          {/* <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            title="Compete"
            route="/competitions"
            label="Issue a game or competition"
          /> */}
          {/* <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            title="Offers"
            route="/perks"
            label="Broadcast an offer"
            isContentTab={true}
          /> */}
          {permissions.events && (
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route={"/event"}
              title="Event"
              label="Add an event"
              isContentTab={true}
            />
          )}
        </div>
      </div>
    </div>
  );

  const renderAddContentTab = () => (
    <div className="dropdown d-inline-block">
      <CommonMenuButton
        type="button"
        className="btn nav-btn top-btn"
        id="page-header-notifications-dropdown"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        hex={brand_data.hex}
        isWhiteFont={brand_data.white}
      >
        Add content
      </CommonMenuButton>
      <div
        className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
        aria-labelledby="page-header-notifications-dropdown"
      >
        <div className="p-2 border-top" style={{ width: "max-content" }}>
          {/* <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/planner"
            title="Scheduler"
            label="Plan content & engagement"
            isContentTab={true}
          /> */}
          {/* <CommonMenuItem
            route={"/cause"}
            title="Gamification Cause"
            label="Donate and earn"
            isContentTab={true}
          /> */}
          {/* <CommonMenuItem
            route="/advent-planner"
            label="Advent Calendar planner"
            isContentTab={true}
          /> */}
          {isHotContentVisible && (
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route="/hot-topic"
              title="Hot Topic"
              label="Broadcast hot talking points and videos"
              isContentTab={true}
            />
          )}
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/featured-content"
            title="Featured Content"
            label="Add a leading content banner"
            isContentTab={true}
          />
          {permissions.feeds && (
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              title="News Feed"
              route="/feeds"
              label="Post content to your feeds"
              isContentTab={true}
            />
          )}
          {permissions.articles && (
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              title="Article"
              route="/articles"
              label="Longform topical article"
              isContentTab={true}
            />
          )}
          {permissions.polls && (
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              title="Polls"
              route="/polls"
              label="List & manage user polls"
              isContentTab={true}
            />
          )}
          {permissions.survey && (
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              title="Survey"
              route="/survey"
              label="Manage multiple answer surveys"
              isContentTab={true}
            />
          )}
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            title="Checklist"
            route="/checklist"
            label="Collect data and tick off"
            isContentTab={true}
          />
          {/* <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            title="Compete"
            route="/competitions"
            label="Issue a game or competition"
            isContentTab={true}
          /> */}
          {/* <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            title="Offers"
            route="/perks"
            label="Broadcast an offer"
            isContentTab={true}
          /> */}
          {permissions.events && (
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route={"/event"}
              title="Event"
              label="Add an event"
              isContentTab={true}
            />
          )}
        </div>
      </div>
    </div>
  );

  const renderModerateContentTab = () => {
    const gotoPath = (pathname) =>
      history.push({
        pathname,
        state: {
          username,
          role,
          brand,
        },
      });

    return (
      <Fragment>
        <CommonMenuButton
          type="button"
          className="btn nav-btn top-btn"
          onClick={() => gotoPath("/moderate-content")}
          hex={brand_data.hex}
          isWhiteFont={brand_data.white}
        >
          Moderate content
        </CommonMenuButton>
      </Fragment>
    );
  };

  const renderTasksTab = () => (
    <div className="dropdown d-inline-block" key="task">
      <CommonMenuButton
        type="button"
        className="btn nav-btn top-btn"
        id="page-header-notifications-dropdown"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        hex={brand_data.hex}
        isWhiteFont={brand_data.white}
      >
        Tasks + Taskers
      </CommonMenuButton>
      <div
        className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
        aria-labelledby="page-header-notifications-dropdown"
      >
        <div className="p-2 border-top">
          <React.Fragment>
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route={"/ticket-types"}
              label="Tasks and ticket types"
            />
            {/* <CommonMenuItem
              route={"/ticket-categories"}
              label="Ticket categories"
            /> */}
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route={"/brand-taskers"}
              label={`${brandName} Taskers`}
            />
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              label="Visit task/ticket submission site"
              onPress={goToTicketSubmissionSite}
            />
          </React.Fragment>
        </div>
      </div>
    </div>
  );
  const renderGamificationTab = () => (
    <div className="dropdown d-inline-block" key="gamificaton">
      <CommonMenuButton
        type="button"
        className="btn nav-btn top-btn"
        id="page-header-notifications-dropdown"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        hex={brand_data.hex}
        isWhiteFont={brand_data.white}
      >
        Gamification
      </CommonMenuButton>
      <div
        className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
        aria-labelledby="page-header-notifications-dropdown"
        style={{ width: "430px" }}
      >
        <div className="p-2 border-top gamification-container">
          <React.Fragment>
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route={isBrand ? "/token-earning-all" : "/earn"}
              title="Gamification Tasks"
              label="View, create and manage all tasks"
            />
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route={isBrand ? "/token-earning-hot" : "/earn"}
              title="Top Tasks"
              label="Set the live and featured tasks for user types"
            />
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route={isBrand ? "/incremental-tasks" : "/earn"}
              title="Incremental Tasks"
              label="Set the live and features tasks for user types"
            />
          </React.Fragment>
        </div>
      </div>
    </div>
  );
  const renderRewardsTab = () => (
    <div className="dropdown d-inline-block" key="rewards">
      {isBrand || isUmbrella ? (
        <React.Fragment>
          <CommonMenuButton
            type="button"
            className="btn nav-btn top-btn"
            id="page-header-notifications-dropdown"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
          >
            Rewards
          </CommonMenuButton>
          <div
            className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
            aria-labelledby="page-header-notifications-dropdown"
          >
            <div className="p-2 border-top">
              <React.Fragment>
                <CommonMenuItem
                  hex={brand_data.hex}
                  isWhiteFont={brand_data.white}
                  route="/tokens-and-pots"
                  label="Tokens and Pots"
                />
                <CommonMenuItem
                  hex={brand_data.hex}
                  isWhiteFont={brand_data.white}
                  route="/spend-tokens"
                  label="Retailers"
                />
                {/* <CommonMenuItem route="/earn-tokens" label="Token Earn" /> */}
                <CommonMenuItem
                  hex={brand_data.hex}
                  isWhiteFont={brand_data.white}
                  route="/perks"
                  label="Offers"
                />
              </React.Fragment>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <CommonMenuButton
            type="button"
            className="btn nav-btn top-btn"
            id="page-header-notifications-dropdown"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
          >
            Earn & Pay
          </CommonMenuButton>
          <div
            className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
            aria-labelledby="page-header-notifications-dropdown"
          >
            <div className="p-2 border-top">
              <React.Fragment>
                <CommonMenuItem
                  hex={brand_data.hex}
                  isWhiteFont={brand_data.white}
                  route="/transactional-ledger"
                  label="Transactional ledger"
                />
                <CommonMenuItem
                  hex={brand_data.hex}
                  isWhiteFont={brand_data.white}
                  route="/retailer"
                  label="EcoPay Retailers"
                />
                <CommonMenuItem
                  hex={brand_data.hex}
                  isWhiteFont={brand_data.white}
                  route="/eco-earn"
                  label="EcoEarn Retailers"
                />
                <CommonMenuItem
                  hex={brand_data.hex}
                  isWhiteFont={brand_data.white}
                  route="/top-retailer"
                  label="Top Retailers"
                />
                <CommonMenuItem
                  hex={brand_data.hex}
                  isWhiteFont={brand_data.white}
                  route="/wallets"
                  label="Token Wallets"
                />
                <CommonMenuItem
                  hex={brand_data.hex}
                  isWhiteFont={brand_data.white}
                  route="/earn"
                  label="Token Earning Tasks"
                />
                <CommonMenuItem
                  hex={brand_data.hex}
                  isWhiteFont={brand_data.white}
                  route="/offers"
                  label="Discounts"
                />
              </React.Fragment>
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );

  const renderMarketplaceTab = () => (
    <div className="dropdown d-inline-block" key="marketplace">
      <CommonMenuButton
        type="button"
        className="btn nav-btn top-btn"
        id="page-header-notifications-dropdown"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        hex={brand_data.hex}
        isWhiteFont={brand_data.white}
      >
        Marketplace
      </CommonMenuButton>
      <div
        className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
        aria-labelledby="page-header-notifications-dropdown"
      >
        <div className="p-2 border-top">
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/products"
            label="Products"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            disabled
            label="Sales Reports"
          />
        </div>
      </div>
    </div>
  );
  const renderSuperContentTab = () => {
    return (
      <div className="dropdown d-inline-block" key="super-content">
        <CommonMenuButton
          type="button"
          className="btn nav-btn top-btn"
          id="page-header-notifications-dropdown"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          hex={brand_data.hex}
          isWhiteFont={brand_data.white}
        >
          Content
        </CommonMenuButton>
        <div
          className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
          aria-labelledby="page-header-notifications-dropdown"
        >
          <div className="p-2 border-top" style={{ width: "max-content" }}>
            {/* <CommonMenuItem
              route="/planner"
              label="Content & engagement planner"

            /> */}
            {/* <CommonMenuItem
            route="/advent-planner"
            label="Advent Calendar planner"
          /> */}
            {/* <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route={"/hot-topic"}
              title="Hot Content"
              label="Broadcast hot talking points and videos"
            /> */}
            {/* <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route={"/featured-content"}
              title="Featured Content"
              label="Add a leading content banner"
            /> */}
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              title="News Feed"
              route="/feeds"
              label="Post content to your feeds"
            />
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              title="Article"
              route="/super-articles"
              label="Longform topical article"
            />
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              title="Polls"
              route="/polls"
              label="List & manage user polls"
            />
            {/* <CommonMenuItem
              title="Survey"
              route="/survey"
              label="Manage multiple answer surveys"
            />
            <CommonMenuItem
              title="Compete"
              route="/competitions"
              label="Issue a game or competition"
            />
            <CommonMenuItem
              title="Offers"
              route="/brand-offers"
              label="Broadcast an offer"
            /> */}
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route={"/event"}
              title="Event"
              label="Add an event"
            />
          </div>
        </div>
      </div>
    );
  };
  const renderEngagementTab = () => {
    if (isCRMChatNotAvailable) return null;
    return (
      <div className="dropdown d-inline-block" key="engagement">
        <CommonMenuButton
          type="button"
          className="btn nav-btn top-btn"
          id="page-header-notifications-dropdown"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          hex={brand_data.hex}
          isWhiteFont={brand_data.white}
        >
          EcoChat
        </CommonMenuButton>
        <div
          className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
          aria-labelledby="page-header-notifications-dropdown"
        >
          <div className="p-2 border-top">
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route="/super-chatsuite"
              label="Member chat and tickets"
            />
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route="/super-support"
              label="Brand chat and tickets"
            />
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route="/super-ticket-types"
              label="Bespoke tickets, tasks and skills"
            />
            {isUmbrella && (
              <CommonMenuItem
                hex={brand_data.hex}
                isWhiteFont={brand_data.white}
                route="/chatbots"
                label="Chatbot"
              />
            )}
          </div>
        </div>
      </div>
    );
  };
  const renderBespokeTab = () => (
    <div className="dropdown d-inline-block" key="bespoke">
      <CommonMenuButton
        type="button"
        className="btn nav-btn top-btn"
        id="page-header-notifications-dropdown"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        hex={brand_data.hex}
        isWhiteFont={brand_data.white}
      >
        Bespoke
      </CommonMenuButton>
      <div
        className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
        aria-labelledby="page-header-notifications-dropdown"
      >
        <div className="p-2 border-top">
          <MenuGroupTitle title="Build chatbot led communications" />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/chatbot-maker"
            title="ChatBots"
            label="Chatbot maker"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/ticket-types"
            title="ConciergeBot"
            label="Set custom concierge Q and As"
          />
          {/* <CommonMenuItem
            route="/auto-concierge"
            title="Checkin Bot"
            label="Daily auto-interactions"
          />
          <CommonMenuItem
            route="/chatbot"
            title="EcoPA"
            label="Personal Assistants"
          /> */}
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/welcome-message"
            title="WelcomeBot"
            label="Bespoke messages"
          />
          {logInOptions.chatbot && (
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route="/login-bot"
              title="LoginBot"
              label="Bespoke welcome message"
            />
          )}
          <MenuGroupTitle title="Customise your UX and functionality" />
          {isAdmin && (
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route="/bespoke-crm-tabs"
              label="Bespoke CRM tabs"
            />
          )}
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/bespoke-live-tools"
            label="Bespoke live tools"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/bespoke-id"
            label="Bespoke Id"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/bespoke-explore"
            label="Bespoke explore"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/bespoke-iframe"
            label="Bespoke iFrame page"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/bespoke-branding"
            label="Bespoke branding"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/bespoke-referrals"
            label="Bespoke referrals"
          />
          {![
            "Sales manager",
            "Sales rep",
            "Service manager",
            "Service rep",
          ].includes(agencyData.type) && (
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route="/user-categories"
              label="Bespoke user categories"
            />
          )}
          {![
            "Sales manager",
            "Sales rep",
            "Service manager",
            "Service rep",
          ].includes(agencyData.type) && (
            <CommonMenuItem
              hex={brand_data.hex}
              isWhiteFont={brand_data.white}
              route="/bespokereviews"
              label="Bespoke reviews content"
            />
          )}
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/admin-email-notifications"
            label="Bespoke admin email notifications"
          />
          {/* <CommonMenuItem
            route={"/tasks-sub-site"}
            label="Bespoke task/ticket submission site"
          /> */}
        </div>
      </div>
    </div>
  );
  const renderIntegrationTab = () => (
    <div className="dropdown d-inline-block" key="integration">
      <CommonMenuButton
        type="button"
        className="btn nav-btn top-btn"
        id="page-header-notifications-dropdown"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        hex={brand_data.hex}
        isWhiteFont={brand_data.white}
      >
        Integrate
      </CommonMenuButton>
      <div
        className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
        aria-labelledby="page-header-notifications-dropdown"
      >
        <div className="p-2 border-top">
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/plugins"
            label="Standalone page iframe plugins"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/iFrame"
            label="Holistic community iframe"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/api"
            label="Api controls"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/users"
            label="Community user data"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/brand-developers"
            label="Developer access"
          />
          <CommonMenuItem
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
            route="/guides"
            label="Integration guide"
          />
          {/* <CommonMenuItem route="/analytics" label="Integration support chat" /> */}
        </div>
      </div>
    </div>
  );
  const renderEcoBankingTab = () => (
    <div className="dropdown d-inline-block" key="eco-bank">
      <CommonMenuButton
        type="button"
        className="btn nav-btn top-btn"
        id="page-header-notifications-dropdown"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        hex={brand_data.hex}
        isWhiteFont={brand_data.white}
      >
        EcoBanking
      </CommonMenuButton>
      <div
        className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
        aria-labelledby="page-header-notifications-dropdown"
      >
        <div className="p-2 border-top">
          <CommonMenuItem label="Banking Licensors" />
          <CommonMenuItem label="Active banking users" />
          <CommonMenuItem label="Pending banking users" />
          <CommonMenuItem label="Card activation" />
        </div>
      </div>
    </div>
  );
  const handleClose = (event) => {
    if (badgeRef.current && badgeRef.current.contains(event.target)) {
      return;
    }
    setUnreadOpen(false);
  };
  const handleToggle = () => {
    setUnreadOpen(!unread_open);
  };
  const onRead = (unread) => {
    if (isBrand) {
      const { id } = unread;
      const index = current_unreads.findIndex((u) => u.id === id);
      let updated_unreads = [...current_unreads];
      updated_unreads.splice(index, 1);
      setCurrentUnReads(updated_unreads);
      Firebase.readUnReadMessages(brandName, unread.id);
      //check if from user or super;
      if (id.split("_").length === 3)
        history.push("/chatsuite", {
          //from user;
          username: username,
          role: role,
          brand: brand,
        });
      else
        history.push("/admin-support", {
          //from user;
          username: username,
          role: role,
          brand: brand,
        });
    } else {
      history.push("/super-support", {
        username: username,
        role: role,
        brand: brand,
      });
    }

    setUnreadOpen(false);
  };
  return (
    <header
      id={
        window.location.pathname === "/users"
          ? "page-header--fixed"
          : "page-header"
      }
    >
      <div className="content-header">
        <button
          onClick={onHome}
          style={{
            backgroundImage:
              logo || (umbrellaBrandData && umbrellaBrandData.logo)
                ? `url(${logo || umbrellaBrandData.logo})`
                : `url(${default_logo})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "contain",
            backgroundColor: "transparent",
            border: "none",
            cursor: "pointer",
            width: 180,
            height: 40,
          }}
        />
        <ul>
          {profile &&
            profile.type === "Content and marketing" &&
            renderContentHeader()}
          {(profile && profile.type === "Content Admin") ||
          (agencyData && agencyData.type === "Content Admin")
            ? renderAddContentTab()
            : null}

          {/* {profile && profile.type === "Content Admin" && renderModerateContentTab()} */}

          {tabsOrder.map((obj) => {
            if (!headers[obj]) return null;
            if (
              (profile &&
                (profile.type === "Content and marketing" ||
                  profile.type === "Content Admin" ||
                  profile.type === "Marketplace lister")) ||
              (agencyData &&
                (agencyData.type === "Content and marketing" ||
                  agencyData.type === "Content Admin" ||
                  agencyData.type === "Marketplace lister"))
            )
              return null;

            if (obj === "programme") return renderProgrammeTab();
            if (obj === "support") return renderSupportTab();
            if (obj === "community") return renderCommunityTab();
            if (obj === "connect") return renderConnectTab();
            if (obj === "referrals") return renderReferralsTab();
            if (obj === "gamification") return renderGamificationTab();
            if (obj === "deal") return renderDealTab();
            if (obj === "tasks") return renderTasksTab();
            if (obj === "content") return renderContentTab();
            if (obj === "rewards") return renderRewardsTab();
            if (obj === "marketplace") return renderMarketplaceTab();
            if (obj === "ecoBanking") return renderEcoBankingTab();
            if (obj === "engagement") return renderEngagementTab();
            if (obj === "bespoke") return renderBespokeTab();
            if (obj === "integration") return renderIntegrationTab();
            if (obj === "propertyPortals")
              return (
                <Fragment key={obj}>
                  <CommonMenuItem
                    hex={brand_data.hex}
                    isWhiteFont={brand_data.white}
                    className="btn nav-btn top-btn"
                    route="/propertyportals"
                    label="PropertyTools"
                  />
                </Fragment>
              );

            if (obj === "superAnalytics")
              return (
                <Fragment key={obj}>
                  <CommonMenuItem
                    hex={brand_data.hex}
                    isWhiteFont={brand_data.white}
                    className="btn nav-btn top-btn"
                    route="/super-analytics"
                    label="Analytics"
                  />
                </Fragment>
              );
            if (obj === "superIntegration")
              return (
                <Fragment key={obj}>
                  <CommonMenuItem
                    hex={brand_data.hex}
                    isWhiteFont={brand_data.white}
                    className="btn nav-btn top-btn"
                    route="/superdevs"
                    label="Integration"
                  />
                </Fragment>
              );

            if (obj === "products")
              return (
                <Fragment key={obj}>
                  <CommonMenuItem
                    hex={brand_data.hex}
                    isWhiteFont={brand_data.white}
                    className="btn nav-btn top-btn"
                    route="/super-products"
                    label="EcoStore"
                  />
                </Fragment>
              );
            if (obj === "superContent") return renderSuperContentTab();
            if (obj === "userPlatform")
              return (
                <Fragment key={obj}>
                  <CommonMenuItem
                    hex={brand_data.hex}
                    isWhiteFont={brand_data.white}
                    className="btn secondary-btn"
                    label="View user platform"
                    onPress={goToCommunity}
                  />
                </Fragment>
              );
            return null;
          })}
        </ul>
        {profile && profile.type !== "Marketplace lister" && (
          <CommonMenuButton
            type="button"
            className="btn nav-btn top-btn fs-12"
            onClick={goToCommunity}
            hex={brand_data.hex}
            isWhiteFont={brand_data.white}
          >
            Test as a user
          </CommonMenuButton>
        )}
        <div className="header-actions-container">
          {/* {process.env.REACT_APP_USER !== "admin" && !isMobileView && (
            <React.Fragment>
              <button
                className="btn btn-hero-lg btn-hero-success view-platform-btn"
                onClick={goToAdminSupport}
              >
                <img src={support_img} alt="support"></img>
              </button>
              <button
                className="btn btn-hero-lg btn-hero-success view-platform-btn"
                onClick={goToCalendarHub}
              >
                <img src={appointment_img} alt="support"></img>
              </button>
              <button
                className="btn btn-hero-lg btn-hero-success view-platform-btn"
                onClick={goToCommunity}
              >
                <img src={platform_img} alt="support"></img>
              </button>
            </React.Fragment>
          )} */}
          {!isCRMChatNotAvailable && current_unreads.length > 0 && (
            <React.Fragment>
              <Badge
                badgeContent={current_unreads.length}
                className="notification_icon"
                color="primary"
                ref={badgeRef}
                onClick={handleToggle}
              >
                <img src={notification_gif} width="50px" height="38px" />
              </Badge>
              <Popper
                open={unread_open}
                anchorEl={badgeRef.current}
                placement="bottom-end"
                transition
                disablePortal
              >
                {({ TransitionProps }) => (
                  <Grow {...TransitionProps}>
                    <Paper>
                      <ClickAwayListener onClickAway={handleClose}>
                        <MenuList
                          autoFocusItem={unread_open}
                          className="menuList"
                        >
                          {current_unreads
                            .sort(compare)
                            .map((unread_item, index) => {
                              return (
                                <MenuItem
                                  key={index}
                                  className="menuItem"
                                  onClick={() => onRead(unread_item)}
                                >
                                  <Message unread_item={unread_item} />
                                </MenuItem>
                              );
                            })}
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </React.Fragment>
          )}
          {isBrand && isUmbrella ? (
            <NavLink
              to={{
                pathname: "/umbrella-channel",
                state: {
                  username: username,
                  role: role,
                  brand: brand,
                },
              }}
            >
              <button className="btn btn-hero-lg btn-hero-success umbrella-admin-btn">
                TO SUPER ADMIN
              </button>
            </NavLink>
          ) : (
            <div className="dropdown d-inline-block">
              <CommonMenuButton
                type="button"
                className="btn nav-btn top-btn"
                id="page-header-notifications-dropdown"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                hex={brand_data.hex}
                isWhiteFont={brand_data.white}
              >
                <i className="fas fa-user" />
                <span className="badge  badge-pill">{username}</span>
              </CommonMenuButton>
              <div
                className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
                aria-labelledby="page-header-notifications-dropdown"
              >
                <div className="p-2 border-top">
                  {/* {role === 1 && (
                  <button
                    className="btn nav-btn btn-light btn-block text-center"
                    onClick={showAgencies}
                  >
                    <i className="fas fa-users" />
                    &nbsp;&nbsp;&nbsp; Profile
                  </button>
                )} */}

                  <NavLink
                    to={{
                      pathname: "/profile",
                      state: {
                        username: username,
                        role: role,
                        brand: brand,
                      },
                    }}
                  >
                    <button
                      className="btn btn-light btn-block"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <i
                        className="fa fa-user"
                        style={{
                          width: 25,
                          height: 30,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "larger",
                        }}
                      />
                      &nbsp;&nbsp;&nbsp; MY ID
                    </button>
                  </NavLink>
                  {isBrand && role === 0 && (
                    <NavLink
                      to={{
                        pathname: "/channel",
                        state: {
                          username: username,
                          role: role,
                          brand: brand,
                        },
                      }}
                    >
                      <button
                        className="btn btn-light btn-block text-center"
                        onClick={() => dispatch({ type: "REMOVE" })}
                      >
                        <i className="nav-main-link-icon si si-arrow-left" />
                        &nbsp;&nbsp;&nbsp;Super Admin Home
                      </button>
                    </NavLink>
                  )}
                  {isAdmin ||
                    (isBrand &&
                      agencyData &&
                      [
                        "Sales manager",
                        "Service manager",
                        "Super admin",
                      ].includes(agencyData.type) && (
                        <Fragment>
                          <button
                            className="btn btn-light text-center w-100"
                            onClick={goToBrandAdmins}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "flex-start",
                            }}
                          >
                            <img
                              src={admin_img}
                              width="30"
                              height="30"
                              alt="admin icon"
                            />
                            &nbsp;&nbsp;&nbsp;Manage admins
                          </button>
                          {/* temporarily disable dashboard page */}
                          {/* {agencyData.type === "Super admin" && (
                            <button
                              className="btn btn-light text-center w-100"
                              onClick={goDashboard}
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "flex-start",
                              }}
                            >
                              <img
                                src={dashboard_img}
                                width="30"
                                height="30"
                                alt="dashboard icon"
                              />
                              &nbsp;&nbsp;&nbsp;View my dashboard
                            </button>
                          )} */}
                        </Fragment>
                      ))}
                  <button
                    className="btn btn-light btn-block text-center"
                    onClick={() => {
                      onSignOut();
                      // reset notification sound
                      dispatch(setNotificationSoundPlayed(false));
                    }}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "flex-start",
                    }}
                  >
                    <img
                      src={signout_img}
                      width="30"
                      height="30"
                      alt="signout"
                    />
                    &nbsp;&nbsp;&nbsp;Sign Out from my crm
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};
export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js